import {createAsyncThunk} from '@reduxjs/toolkit';
import {metaDataService} from '../service/meta-data-service';
import {AxiosResultStatus} from '../../shared/service/axios-result-status';
import { showErrorStatus } from '../../security/state/user-slice';

export const getMetaData = createAsyncThunk(
    "metaData/getMetaData",
    async (param: void, thunkAPI) => {

    const response = await Promise.all([
        metaDataService.getPatientEncounterMetaData(),
        metaDataService.getPaymentChannels()
    ])

    response.forEach((metaDataResponse:Awaited<AxiosResultStatus>) => {
       if(metaDataResponse.hasErrors){
           thunkAPI.dispatch(showErrorStatus(metaDataResponse.errorMessage));
           throw new Error(metaDataResponse.errorMessage);
       }
    })

    const [patientEncounterMetaData, paymentChannelMetaData] = response;

    return{
        ...patientEncounterMetaData.entity,
        paymentChannel: paymentChannelMetaData.entity
    }
    }
)